var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgElevator = function SvgElevator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.5,
    height: 28.854,
    viewBox: "0 0 30.5 28.854"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    ransform: "translate(0.5 -0.253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    x2: 13.088,
    transform: "translate(5.99 27.768)",
    fill: "none",
    stroke: "#bfc9c6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    x1: 2.066,
    transform: "translate(27.934 15.042)",
    fill: "none",
    stroke: "#bfc9c6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    x1: 2.066,
    transform: "translate(27.934 18.042)",
    fill: "none",
    stroke: "#bfc9c6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    y1: 28.355,
    transform: "translate(24.901 0.753)",
    fill: "none",
    stroke: "#bfc9c6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_88",
    y1: 28.355,
    transform: "translate(0 0.753)",
    fill: "none",
    stroke: "#bfc9c6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    x1: 25,
    transform: "translate(0 0.753)",
    fill: "none",
    stroke: "#bfc9c6",
    strokeWidth: 1
  })))));
};

export { SvgElevator as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMC41IiBoZWlnaHQ9IjI4Ljg1NCIgdmlld0JveD0iMCAwIDMwLjUgMjguODU0Ij4KICA8ZyBpZD0iR3JvdXBfNTIiIHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC41IC0wLjI1MykiPgogICAgPGcgaWQ9Ikdyb3VwXzUxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIj4KICAgICAgPGxpbmUgaWQ9IkxpbmVfODUiIHgyPSIxMy4wODgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUuOTkgMjcuNzY4KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjYmZjOWM2IiBzdHJva2Utd2lkdGg9IjEiLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfODYiIHgxPSIyLjA2NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjcuOTM0IDE1LjA0MikiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2JmYzljNiIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzkwIiB4MT0iMi4wNjYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI3LjkzNCAxOC4wNDIpIiBmaWxsPSJub25lIiBzdHJva2U9IiNiZmM5YzYiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgICA8bGluZSBpZD0iTGluZV84NyIgeTE9IjI4LjM1NSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjQuOTAxIDAuNzUzKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjYmZjOWM2IiBzdHJva2Utd2lkdGg9IjEiLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfODgiIHkxPSIyOC4zNTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMC43NTMpIiBmaWxsPSJub25lIiBzdHJva2U9IiNiZmM5YzYiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgICA8bGluZSBpZD0iTGluZV84OSIgeDE9IjI1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDAuNzUzKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjYmZjOWM2IiBzdHJva2Utd2lkdGg9IjEiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";